import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import AdminPagesPage from './pages/admin/PagesPage';
import AdminSectionsPage from './pages/admin/SectionsPage';
import AdminMediaPage from './pages/admin/MediaPage';
import AdminSettingsPage from './pages/admin/SettingsPage';
import AdminUsersPage from './pages/admin/UsersPage';
import AdminCategoriesPage from './pages/admin/CategoriesPage';
import AdminItemsPage from './pages/admin/ItemsPage';
import AdminPackagesPage from './pages/admin/PackagesPage';
import AdminPOSPage from './pages/admin/POSPage';
import AdminOrdersPage from './pages/admin/OrdersPage';
import AdminPostsPage from './pages/admin/PostsPage';
import OperationWorkersPage from './pages/admin/OperationWorkersPage';
import OperationInventoryPage from './pages/admin/OperationInventoryPage';
import OperationAssignmentsPage from './pages/admin/OperationAssignmentsPage';
import OperationCategoriesPage from './pages/admin/OperationCategoriesPage';
import OperationPositionsPage from './pages/admin/OperationPositionsPage';
import OperationDepartmentsPage from './pages/admin/OperationDepartmentsPage';
import ProtectedRoute from './components/admin/ProtectedRoute';
import NotFoundPage from './pages/NotFoundPage';
import ErrorBoundary from './components/admin/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
      <Routes>
        {/* Admin CMS */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/admin/pages" element={<ProtectedRoute><AdminPagesPage /></ProtectedRoute>} />
        <Route path="/admin/posts" element={<ProtectedRoute><AdminPostsPage /></ProtectedRoute>} />
        <Route path="/admin/sections" element={<ProtectedRoute><AdminSectionsPage /></ProtectedRoute>} />
        <Route path="/admin/media" element={<ProtectedRoute><AdminMediaPage /></ProtectedRoute>} />
        <Route path="/admin/settings" element={<ProtectedRoute><AdminSettingsPage /></ProtectedRoute>} />
        <Route path="/admin/users" element={<ProtectedRoute><AdminUsersPage /></ProtectedRoute>} />
        <Route path="/admin/categories" element={<ProtectedRoute><AdminCategoriesPage /></ProtectedRoute>} />
        <Route path="/admin/items" element={<ProtectedRoute><AdminItemsPage /></ProtectedRoute>} />
        <Route path="/admin/layanan" element={<ProtectedRoute><AdminItemsPage /></ProtectedRoute>} />
        <Route path="/admin/packages" element={<ProtectedRoute><AdminPackagesPage /></ProtectedRoute>} />
        <Route path="/admin/pos" element={<ProtectedRoute><AdminPOSPage /></ProtectedRoute>} />
        <Route path="/admin/orders" element={<ProtectedRoute><AdminOrdersPage /></ProtectedRoute>} />
        <Route path="/admin/operation-workers" element={<ProtectedRoute><OperationWorkersPage /></ProtectedRoute>} />
        <Route path="/admin/operation-inventory" element={<ProtectedRoute><OperationInventoryPage /></ProtectedRoute>} />
        <Route path="/admin/operation-assignments" element={<ProtectedRoute><OperationAssignmentsPage /></ProtectedRoute>} />
        <Route path="/admin/operation-categories" element={<ProtectedRoute><OperationCategoriesPage /></ProtectedRoute>} />
        <Route path="/admin/operation-positions" element={<ProtectedRoute><OperationPositionsPage /></ProtectedRoute>} />
        <Route path="/admin/operation-departments" element={<ProtectedRoute><OperationDepartmentsPage /></ProtectedRoute>} />
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;